const statusParcelaList = [
    {
        id: 'P', // HARDCODE.idStatusParcelaPaga
        descricao: 'Paga',
        chaves: [
            {
                id: 'PAGA',
            },
            {
                id: 'pago',
            },
            {
                id: 'Pago',
            },
            {
                id: 'Quitado',
            },
        ],
        aberta: 'N',
        cancelada: 'N',
        paga: 'S',
        ordem: 10,
    },
    {
        id: 'C',
        descricao: 'Cancelada',
        chaves: [
            {
                id: 'CANCELADA',
            },
        ],
        aberta: 'N',
        cancelada: 'S',
        paga: 'N',
        ordem: 20,
    },
    {
        id: 'E',
        descricao: 'Pendente',
        chaves: [
            {
                id: 'EMITIDA',
            },
            {
                id: 'pendente',
            },
            {
                id: 'Aguardando Pagamento',
            },
            {
                id: 'OUTROS',
            },
            {
                id: 'Pendente',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 30,
    },
    {
        id: 'T',
        descricao: 'Em Trânsito',
        chaves: [
            {
                id: 'EM_TRANSITO',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 40,
    },
    {
        id: 'I',
        descricao: 'Inconsistente',
        chaves: [
            {
                id: 'INCONSISTENTE',
            },
        ],
        aberta: 'N',
        cancelada: 'S',
        paga: 'N',
        ordem: 50,
    },
    {
        id: 'R',
        descricao: 'Recusada',
        chaves: [
            {
                id: 'RECUSADA',
            },
        ],
        aberta: 'N',
        cancelada: 'S',
        paga: 'N',
        ordem: 60,
    },
    {
        id: 'B',
        descricao: 'Reembolsada',
        chaves: [
            {
                id: 'Reembolsado',
            },
            {
                id: 'Restituído',
            },
        ],
        aberta: 'N',
        cancelada: 'S',
        paga: 'N',
        ordem: 70,
    },
    {
        id: 'F',
        descricao: 'Aguardando Faturamento',
        chaves: [
            {
                id: 'Aguardando Faturamento',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 80,
    },
    {
        id: 'G',
        descricao: 'Aguardando Confirmação da Seguradora',
        chaves: [
            {
                id: 'Aguardando Confirmação da Seguradora',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 85,
    },
    {
        id: 'L',
        descricao: 'Em Alerta',
        chaves: [
            {
                id: 'Em Alerta',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 90,
    },
    {
        id: 'M',
        descricao: 'Faturamento Em Atraso',
        chaves: [
            {
                id: 'Faturamento Em Atraso',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 100,
    },
    {
        id: 'D',
        descricao: 'Inadimplente',
        chaves: [
            {
                id: 'Inadimplente',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 110,
    },
    {
        id: 'S',
        descricao: 'Inscrição em Regularização de Status',
        chaves: [
            {
                id: 'INSCRIÇÃO EM REGULARIZAÇÃO DE STATUS',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 120,
    },
    {
        id: 'V',
        descricao: 'Sem Expectativa de Recebimento',
        chaves: [
            {
                id: 'Sem Expectativa de Recebimento',
            },
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 130,
    },
    {
        id: 'A', // HARDCODE.idStatusParcelaEstimada
        descricao: 'Estimada',
        chaves: [
        ],
        aberta: 'S',
        cancelada: 'N',
        paga: 'N',
        ordem: 140,
    },
]

export default statusParcelaList